var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(`Your next session begins in ${_vm.timeLeft} minutes.`)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }